// nb.ui.summary.util
import { MetricItem } from 'schemas/MetricItemSchema'
import { AnalysisTypeStrings } from 'enums/AnalysisType'
import ViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import MeasureType, { MeasureTypeStrings } from 'enums/MeasureType'
import {
  ChartType,
  ChartTypeStrings
} from 'components/visualization/MetricGrid/MetricItem/types/chartType'
import { getChildTypes } from './MetricItemUtil'

export const getMeasureTypes = (metricItems: MetricItem[]) => {
  const types = []
  for (let i = 0; i < metricItems.length; i += 1) {
    const metricItem = metricItems[i]
    if (metricItem.category) {
      types.push(metricItem.category)
    }
  }
  return types
}

export const getAllMeasureTypes = (
  analysisType: AnalysisTypeStrings,
  viewOption: InsightViewOptionStrings,
  measureTypes: MeasureTypeStrings[]
) => {
  const types = []
  if (measureTypes) {
    for (let i = 0; i < measureTypes.length; i += 1) {
      const measureType = measureTypes[i]
      types.push(measureType)

      if (
        !(
          viewOption === ViewOption.OVERVIEW &&
          (measureType === MeasureType.MENTIONS || measureType === MeasureType.UNIQUE_AUTHORS)
        )
      ) {
        const children = getChildTypes(analysisType, viewOption, measureType)
        for (let j = 0; j < children.length; j += 1) {
          types.push(children[j])
        }
      }
    }
  }
  return types
}

export const getChartType = (
  measureType: MeasureTypeStrings,
  viewOption: InsightViewOptionStrings
) => {
  // TODO: VoC chart type
  // if (isMeasurementType(viewOption)) {
  //   return ChartType.ROUND_BAR
  // }
  let chartType: ChartTypeStrings
  if (viewOption === ViewOption.CHANNELS && measureType === MeasureType.NET_SENTIMENT) {
    chartType = ChartType.SCALE_BAR
  } else if (viewOption === ViewOption.CHANNELS) {
    chartType = ChartType.ROUND_BAR
  } else if (
    [
      MeasureType.NET_SENTIMENT,
      MeasureType.PASSION_INTENSITY,
      MeasureType.ENGAGEMENT_RATIO
    ].includes(measureType)
  ) {
    chartType = ChartType.SPEED_DIAL
  } else {
    chartType = ChartType.DONUT
  }
  return chartType
}
